<template>
  <f7-view>

    <!-- Settigns page -->
    <f7-page>
      <f7-navbar :title="trans('title:settings')"></f7-navbar>
      <f7-block><a :href="trans('help:url')" target="_blank" rel="noopener" class="external">{{ trans('help:title') }}</a></f7-block>
      <f7-list no-hairlines>
        <f7-list-item>
          <span>
            <i class="fa fa-fw fa-location-arrow"></i>
            {{ 'label:cfg:location'|trans }}
          </span>
          <f7-toggle :checked="geolocationEnabled" @toggle:change="geolocationEnabledChanged($event)" />
        </f7-list-item>
        <f7-list-button color="red" @click="onSettingsShow(dialogs.CLEAR_CONFIG)">
          <i class="fa fa-fw fa-trash"></i>
          {{ 'btn:clear_config'|trans }}
        </f7-list-button>
      </f7-list>
    </f7-page>

    <!-- clear preferences popup -->
    <f7-popup :opened="clearConfigPopupOpened" @popup:closed="clearConfigPopupOpened = false;" swipe-to-close>
      <f7-page login-screen>
        <f7-navbar>
          <f7-nav-right>
            <f7-link popup-close>{{ 'nav:close'|trans }}</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <f7-login-screen-title>{{ 'title:clear_config'|trans }}</f7-login-screen-title>
          <f7-button fill color="red" @click="clearConfigClicked()">
            <i class="fa fa-lg fa-trash"></i>
            {{ 'btn:delete'|trans }}
          </f7-button>
          <f7-block-footer>
            {{ 'info:clear_config'|trans }}
          </f7-block-footer>
        </f7-block>
      </f7-page>
    </f7-popup>

  </f7-view>
</template>

<script>
  import EventBus from '../js/event-bus.js';
  import Preferences from '../js/preferences.js';

  export const SHOW = 'settings:show';
  export const dialogs = {
    CLEAR_CONFIG: 'clear_config'
  }

  export default {
    data() {
      return {
        clearConfigPopupOpened: false,
        dialogs: dialogs
      }
    },
    methods: {
      geolocationEnabledChanged: function(val) {
        this.geolocationEnabled = val;
      },
      clearConfigClicked() {
        var self = this;
        this.$f7.dialog.confirm(this.trans('confirm:clear_config'), null, function() {
          this.$emit('close')
          this.clearConfigPopupOpened = false;
          Preferences.clear();
          this.$f7.views.main.router.navigate('/');
        }.bind(self));
      },
      onSettingsShow(what) {
        if (typeof what === 'undefined') this.$emit('open')
        else if (what === dialogs.CLEAR_CONFIG) this.clearConfigPopupOpened = true;
      }
    },
    computed: {
      geolocationEnabled: {
        get() { return Preferences.getGeolocationEnabled(); },
        set(newVal) {
          Preferences.setGeolocationEnabled(newVal);
        }
      }
    },
    mounted() {
      EventBus.$on(SHOW, this.onSettingsShow);
    },
    beforeDestroy() {
      EventBus.$off(SHOW, this.onSettingsShow);
    }
  }
</script>
